import { useHistory } from 'react-router-dom';
import { IWTButton } from '../IWTButton';
import { Pages } from '../../../utils/constants';
import { useGlobalState } from '../../../state/state';
import { useState } from 'react';
import { hasPITOrPendingChange } from '../../../utils/ruleHelper';
import { PITWarningModal } from '../../PITWarningModal/PITWarningModal';
import { UtagHelper } from '../../../utils/UtagHelper';

export interface IManageMembershipIWTProps {
  variant?: 'small';
}

export const ManageMembershipIWT = ({ variant }: IManageMembershipIWTProps) => {
  const history = useHistory();
  const [memberDetails] = useGlobalState('memberDetails');
  const [showPITWarningModal, setShowPITWarningModal] = useState(false);
  const hasPITPendingChange = hasPITOrPendingChange(memberDetails);

  const onClick = () => {
    if (hasPITPendingChange) {
      setShowPITWarningModal(true);
    } else {
      history.push({
        pathname: Pages.ManageMembershipPage,
        search: window.location.href.includes(Pages.MembersDetailsPage)
          ? UtagHelper.getIntcmpQueryParam(Pages.MembersDetailsPage, undefined, Pages.ManageMembershipPage)
          : UtagHelper.getIntcmpQueryParam(Pages.HomePage, 'iwantto_', Pages.ManageMembershipPage),
      });
    }
  };

  return (
    <>
      <IWTButton title="Manage membership" id="ManageMembershipIWT" variant={variant} onClick={onClick} />
      <PITWarningModal
        visible={showPITWarningModal}
        onClose={() => {
          setShowPITWarningModal(false);
        }}
      />
    </>
  );
};
